import React, { useState } from "react";
import NavbarFooterWrapper from "./NavbarFooterWrapper";
import CalendlyWidget from "./CalendlyWidget";

const HomePage = () => {
  return (
    <NavbarFooterWrapper>
      <section className="hero">
        <h1>Nobody works harder than an AI agent.</h1>
        <p>
          Automate workflows, unlock business intelligence, and supercharge your team.  
        </p>
        <div className="hero-buttons">
        <a href="#calendar-booking" className="primary-btn">Get started</a>
        </div>
      </section>

      {/* Agent Types Bar */}
      <section className="agent-types-bar">
        <div className="agent-types-bar-inner">
          <span className="agent-type">Lead Generation</span>
          <span className="agent-type">Sales & CRM Management</span>
          <span className="agent-type">Chatbots & Support</span>
          <span className="agent-type">Operations & Delivery</span>
        </div>
      </section>
      
      {/* Calendar Booking Section */}
      <h2 className="calendar-headline">Discover how AI can help you scale and automate without adding complexity.</h2>
      <section id="calendar-booking" className="connect-form-container">
        <div className="connect-form" style={{ alignItems: 'center', textAlign: 'center' }}>
          <p className="calendar-info" style={{ textAlign: 'left', width: '100%' }}>
            Schedule a free consultation with our team:
          </p>
          <div className="calendly-embed-full">
            <CalendlyWidget url="https://calendly.com/sav-agenticfarms/30min?" />
          </div>
        </div>
      </section>

      

      <section className="why-us">
        <div className="why-us-left">
          <h2>Why Us?</h2>

          <div className="why-point">
            <span className="emoji">⚡</span>
            <div>
              <h4>Collaboratively built</h4>
              <p>Just like our agents, we work best by working with you. The result? Something you actually need.</p>
            </div>
          </div>

          <div className="why-point">
            <span className="emoji">🤖</span>
            <div>
              <h4>Human-friendly AI agents</h4>
              <p>No coding needed – our AI solutions are designed for everyone</p>
            </div>
          </div>

          <div className="why-point">
            <span className="emoji">🧩</span>
            <div>
              <h4>Built with strategy</h4>
              <p>Strategic approach with design thinking for ease of use and scalability.</p>
            </div>
          </div>
        </div>

        <div className="why-us-right">
          <img src="/AF-tilling.png" alt="Robot in field" />
        </div>
      </section>

      <section id="services" className="services">
        <h2>We build AI agents.</h2>
        <p className="services-subhead">High ROI automations built for immediate impact.</p>
        <div className="services-list">
          <div className="service-block">
            <h3><img src="/bolt.png" alt="Lead Generation" className="service-icon" /> Lead Generation</h3>
            <p><strong>Fill your pipelines with qualified leads and zero manual labour required.</strong></p>
            <ul>
              <li>Research & segment your ICP</li>
              <li>Reach out via LinkedIn, Email & WhatsApp</li>
              <li>Score and qualify leads automatically</li>
            </ul>
          </div>
          <div className="service-block">
            <h3><img src="/chart.png" alt="Sales & CRM Management" className="service-icon" /> Sales & CRM Management</h3>
            <p><strong>More selling. Less CRM chaos.</strong></p>
            <ul>
              <li>CRM cleanup & structure</li>
              <li>AI-generated proposals & meeting notes</li>
              <li>Smart follow-ups & reminders</li>
            </ul>
          </div>
          <div className="service-block">
            <h3><img src="/chat.png" alt="Chatbots & Support" className="service-icon" /> Chatbots & Support</h3>
            <p><strong>24/7 brand-safe AI agents.</strong></p>
            <ul>
              <li>Personalized support bots</li>
              <li>Ticket triage & resolution</li>
              <li>Human-like tone, always on-brand</li>
            </ul>
          </div>
          <div className="service-block">
            <h3><img src="/wrench.png" alt="Operations & Delivery" className="service-icon" /> Operations & Delivery</h3>
            <p><strong>Backend ops on autopilot.</strong></p>
            <ul>
              <li>AI onboarding flows</li>
              <li>Task assignment & reporting</li>
              <li>Invoicing & finance automation</li>
            </ul>
          </div>
          <div className="service-block">
            <h3><img src="/chip.png" alt="Custom AI Agents & Automation" className="service-icon" /> Custom Automations</h3>
            <p><strong>Your workflow. Upgraded by agents.</strong></p>
            <ul>
              <li>Tailored AI agents for your workflows</li>
              <li>Seamless integrations with your tools</li>
              <li>Built for speed, scale & measurable ROI</li>
            </ul>
          </div>
          <div className="service-block">
            <h3><img src="/shield.png" alt="AI Strategy Consulting" className="service-icon" /> AI Strategy Consulting</h3>
            <p><strong>A roadmap to real ROI.</strong></p>
            <ul>
              <li>Opportunity mapping & use case analysis</li>
              <li>End-to-end workflow consulting</li>
              <li>A clear, custom implementation plan</li>
            </ul>
          </div>
        </div>
      </section>

      {/* AI Audit  section */}
      <section className="ai-audit-cta">
        <div className="ai-audit-container">
          <h2>Try an AI Audit.</h2>
          <p>Your business is waiting to be automated. We'll help you identify ways to create efficiencies and increase productivity.</p>
          <a href="#calendar-booking" className="white-btn">Get started</a>
        </div>
      </section>

      <section className="process">
        <div className="process-illustration">
          <img src="/AF-tractor.png" alt="AI-powered farm landscape" />
        </div>
        <div className="process-steps">
          <h2>How it's done on the farm.</h2>
          <p className="subtitle">
            This is the most disruptive technology we've seen in years. 
            So let's keep it simple, iterative, and fun. </p>

            <div className="process-step">
              <div className="process-step-icon">💡</div>
              <div className="process-step-content">
                <h4>Discover</h4>
                <p>We'll begin by developing an understanding of your unique opportunity.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="process-step-icon">🧩</div>
              <div className="process-step-content">
                <h4>Strategize</h4>
                <p>Our team develops a detailed strategy and roadmap to bring that opportunity into the world.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="process-step-icon">🔧</div>
              <div className="process-step-content">
                <h4>Develop</h4>
                <p>We get busy building, keeping you updated along the way.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="process-step-icon">🚀</div>
              <div className="process-step-content">
                <h4>Launch</h4>
                <p>You receive your product and ongoing support throughout its implementation.</p>
              </div>
            </div>
        </div>
      </section>

      <section className="cta">
        <h2>Ready to transform your business?</h2>
        <p>Let's discuss how our AI solutions can help you achieve your goals.</p>
        <a href="#calendar-booking" className="primary-btn">Get started</a>
      </section>
    </NavbarFooterWrapper>
  );
};

const ToolStack = ({ img, title, description, reverse }) => (
  <div className={`tool-stack-row${reverse ? ' reverse' : ''}`}>
    <div className="tool-stack-img">
      <img src={img} alt={title} className="tool-image" />
    </div>
    <div className="tool-stack-text">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
);

export default HomePage;